<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createCategory" isAdd class="ml-2" :to="{ name: 'CreateCourseCategory' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getCourseCategoryData()"
      actionViewRouteLink="CourseCategoryDetails"
      @delete-clicked="handleDelete($event)"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'CourseCategoryList',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'category_code', text: vm.$t('courseCategoryCode'), width: 150 },
        { value: 'category_name', text: vm.$t('courseCategoryName'), width: 250 },
        { value: 'center_name', text: vm.$t('campus'), width: 500 },
      ]
      if (this.$validate.allowAction('CourseCategoryDetails', this.userType)) {
        headers.push({ value: 'actionViewAndDelete', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateCourseCategory', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getCourseCategoryData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }
      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
          join_school_data: true,
        }
        const selectedSchool = this.gfGetUserSelectedSchool()
        if (selectedSchool > -1) {
          payload['center_id'] = selectedSchool
        }

        const { data, total } = await this.$Fetcher.GetCourseCategories(payload)
        this.tableData = data.map(el => {
          return {
            id: el.id,
            category_code: el.category_code,
            category_name: el.name,
            center_name: this.$t(el.center_name),
          }
        })

        this.tableItemTotal = total
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    // -- (刪除)
    async handleDelete(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          const courseIds = await this.$Fetcher.DeleteCourseCategory(id, this.gEnableAutoGenCourse)
          if (this.$validate.DataValid(courseIds, true)) {
            this._deleteCourses(courseIds)
            return
          }

          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
          })
          this.tableFilter.page = 1
          this.getCourseCategoryData()
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        }
      }
    },
    async _deleteCourses(courseIds, count = 0) {
      let done = false
      if (count < courseIds.length) {
        try {
          await this.$Fetcher.DeleteCourse(courseIds[count])
          count += 1
          this._deleteCourses(courseIds, count)
        } catch (err) {
          this.$common.error(err)
          done = true
        }
      } else {
        done = true
      }

      if (done) {
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.deleteSuccess',
          type: 'success',
        })
        this.tableFilter.page = 1
        this.getCourseCategoryData()
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: CourseCategoryList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getCourseCategoryData(false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>
